import React from 'react';
import PropTypes from 'prop-types';
import ResizedImage from '../../../../resized-image/resized-image';
import { ClampText } from '@wix/wix-vod-shared/components';
import s from './item-info-cover.scss';

const COVER_WIDTH = 580;
const COVER_HEIGHT = 326;

export const ItemInfoCover = ({ src, title, subtitle }) => (
  <div className={s.container}>
    <ResizedImage
      src={src}
      style={{ width: 'inherit', height: 'inherit' }}
      width={COVER_WIDTH}
      height={COVER_HEIGHT}
    />
    <div className={s.info}>
      {title && <ClampText className={s.title} text={title} wrapperTag="h1" />}
      {subtitle && <h2 className={s.subtitle}>{subtitle}</h2>}
    </div>
  </div>
);

ItemInfoCover.propTypes = {
  src: PropTypes.string.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
};
